var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProductCircleFlagChina(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_2200)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_188_2200)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "#F6F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 0H0V68H68V0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2623 22.2376L24.8576 30.2254H33.2565L26.4617 35.1621L29.0571 43.1499L22.2623 38.2132L15.4674 43.1499L18.0628 35.1621L11.2678 30.2254H19.6668L22.2623 22.2376Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6244 48.8038L36.0762 46.9524L33.5283 48.8037L34.5014 45.8083L31.9534 43.9569H35.1032L36.0762 40.9616L37.0498 43.9569H40.1992L37.6512 45.8082L38.6244 48.8038Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2683 39.6546H42.1187L41.1454 42.6501L40.1722 39.6548L37.0225 39.6546L39.5707 37.8032L38.5974 34.8081L41.1456 36.6591L43.6936 34.8079L42.7203 37.8032L45.2683 39.6546Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2681 28.3465L42.7201 30.198L43.6934 33.193L41.1455 31.3421L38.5972 33.1933L39.5706 30.1977L37.0225 28.3465L40.1721 28.3464L41.1455 25.3508L42.1186 28.3464L45.2681 28.3465Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6241 19.1971L37.651 22.1927L40.1989 24.0438L37.0497 24.044L36.0761 27.0397L35.1029 24.0438L31.9534 24.0441L34.5014 22.1925L33.528 19.197L36.0759 21.0485L38.6241 19.1971Z",
    fill: "#FFDA44"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_2200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    rx: 34,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_188_2200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductCircleFlagChina);
export default __webpack_public_path__ + "static/media/product-circle-flag-china.4f980e2dc5b03b236d15a687c3b64e09.svg";
export { ForwardRef as ReactComponent };